import { Plus, X } from 'lucide-react';
import { ReactNode, useState } from 'react';

interface SpeedDialAction {
  icon: ReactNode;
  label: string;
  onClick: () => void;
}

interface QuickActionsSpeedDialProps {
  actions: SpeedDialAction[];
}

export function QuickActionsSpeedDial({ actions }: QuickActionsSpeedDialProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="fixed bottom-6 left-6 z-40 flex flex-col items-start">
      {/* Expanded Actions */}
      <div
        className={`flex flex-col items-start gap-4 mb-4 transition-all duration-300 origin-bottom ${
          isOpen ? 'scale-100 opacity-100 translate-y-0' : 'scale-0 opacity-0 translate-y-10 pointer-events-none'
        }`}
      >
        {actions.map((action, index) => (
          <div key={index} className="flex items-center gap-3 group">
            <button
              type="button"
              onClick={() => {
                action.onClick();
                setIsOpen(false);
              }}
              className="w-12 h-12 flex items-center justify-center rounded-full bg-white border border-gray-200 shadow-lg text-gray-700 hover:text-blue-600 hover:border-blue-300 transition-all hover:scale-110"
              title={action.label}
            >
              {action.icon}
            </button>
            <div className="bg-gray-900 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap shadow-sm">
              {action.label}
            </div>
          </div>
        ))}
      </div>

      {/* Main Toggle Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`w-14 h-14 flex items-center justify-center rounded-full shadow-xl transition-all duration-300 hover:scale-110 active:scale-95 ${
          isOpen ? 'bg-gray-800 text-white rotate-45' : 'bg-blue-600 text-white'
        }`}
        aria-label="Acciones rápidas"
      >
        {isOpen ? <X className="w-8 h-8" /> : <Plus className="w-8 h-8" />}
      </button>

      {/* Backdrop for closing when clicking outside */}
      {isOpen && <div className="fixed inset-0 bg-black/5 z-[-1]" onClick={() => setIsOpen(false)} />}
    </div>
  );
}
